<template>
    <div class="uk-card uk-card-default uk-card-body uk-text-left">
        <h2>Help</h2>
        <ul class="uk-list uk-list-divider">
            <li>
                <p>Online ordering may NOT have been selected by all Schools. If your Proofcard does not display an Online Code please place order by returning your order form to the school.</p>
            </li>
            <li>
                <p>The Online Code is case sensitive, please ensure this is entered as it appears on your Proofcard.</p>
            </li>
            <li>
                <p>Your Photocard will appear here once you have entered the details on the form. There will also be a smaller preview on the products page.</p>
            </li>
            <li>
                <p>If you have any issues with your product code, or need help ordering, please get in touch.</p>
                <a class="uk-button uk-button-default uk-margin" href="mailto:info@landonroadphotographers.com">Email</a> info@landonroadphotographers.com<br>
                <a class="uk-button uk-button-default uk-margin" href="tel:07861683382">Telephone</a> 07861 683382<br>
            </li>
            <li>
                <h4>Multiple/Sibling Orders</h4>
                <p>While we work on improvements to our new system, it does not yet handle multiple orders of sibling photographs, for the moment we ask that you place one order per Online Code. So your not charged multiple times for Home Delivery, select it your first
                    order, and select School Delivery for any additional orders. We will group all your orders matching your email / address and will be delivered to the same location.</p>
            </li>
            <li>
                <h4>Downloads</h4>
                <p>If you have only Downloads selected, our system does not yet clear the delivery cost, so we ask that you select School Delivery for these orders so that your not charged a delivery cost.</p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //
        }
    },
};
</script>
